import Entity, { TEntity } from '@/plugins/podolib/services/entities/Entity';

/*export type TStation = {
  serial: string;
  mac: string;
  name: string;
  activated: true;
  online: false;
  version: string;
};*/

/**
 * @author Damien CORLER <d.corler@zhortech.com>
 * @since 1.0.0
 * @version 1.0.0
 */
export default class EntityAcquisitions extends Entity<any> {
  name: string = 'acquisitions';
  public startListener() {
    this.Vue.prototype.$pdc.repository.socket.session.on('acquisitions created', (ressource: any) => {
      let patients = this.Vue.prototype.$pdc.entities.patients.storedEntity;
      let patient = patients.list.find((x: any) => x._id === ressource.patient);

      if (!patient) return;

      if (patient.acquisitions) {
        patient.acquisitions.push(ressource);
      } else {
        patient.acquisitions = [ressource];
      }
      patient.acquisitions = patient.acquisitions.sort((a: any, b: any) => {
        const keyA = new Date(a.createdAt);
        const keyB = new Date(b.createdAt);
        // Compare the 2 dates
        if (keyA < keyB) return 1;
        if (keyA > keyB) return -1;
        return 0;
      });
      this.store.commit('pdc/entities/patients/PATCH_ONE', patient);
      return ressource;
    });

    this.Vue.prototype.$pdc.repository.socket.session.on('acquisitions removed', (ressource: any) => {
      let patients = this.Vue.prototype.$pdc.entities.patients.storedEntity;
      let patient = patients.list.find((x: any) => x._id === ressource.patient);
      patient.acquisitions = patient.acquisitions.filter((x: any) => x._id !== ressource._id);
      this.store.commit('pdc/entities/patients/PATCH_ONE', patient);
      return ressource;
    });

    // TODO find a better solution
    this.Vue.prototype.$pdc.repository.socket.session.on(`${this.name} patched`, (ressource: any) => {
      const patients = this.Vue.prototype.$pdc.entities.patients.storedEntity;
      const patient = patients.list.find((x: any) => x._id === ressource.patient);
      patient.acquisitions = patient.acquisitions.map((x: any) => {
        if (x._id === ressource._id) return ressource;
        else return x;
      });

      this.store.commit(`pdc/entities/patients/PATCH_ONE`, patient);
      return ressource;
    });

    this.extendListeners();
  }

  public resumeAcquisition(command: any) {
    this.Vue.prototype.$pdc.bus!.emit('acquisition:dialog:resume', command);
  }
}
